export default __webpack_public_path__ + "d91c22eb00c7ee6bb91591789d197f66.svg";